import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { Footer } from "../../../components/FooterV2";
import { SolutionIndustryCustomer } from "../../../blocks/solution-industry-customer";
import { SolutionIndustrySupport } from "../../../blocks/solution-industry-support";
import { CommonPageLink } from "../../../blocks/common-page-link";
import { HomeTryOn } from "../../../blocks/home-try-on";
import { useTranslation } from "react-i18next";
import { SolutionSceneValue } from "../../../blocks/solution-scene-value";
import { SolutionIndustryBanner } from "../../../blocks/solution-industry-banner";
import { SolutionSceneIntro } from "../../../blocks/solution-scene-intro";
import { SolutionSceneTable } from "../../../blocks/solution-scene-table";
import { SolutionSceneKeycloakCompare } from "../../../blocks/solution-scene-keycloak-compare";
import { Helmet } from "react-helmet";

export const KeycloakPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const data = [
    {
      nametype: t("solution.keycloak.table.fun"),
      title: t("solution.keycloak.table.tableList.item1"),
      dataIndex: "title",
      keycloak: "checked",
      authing: "checked",
    },
    {
      nametype: "Keycloak",
      title: t("solution.keycloak.table.tableList.item2"),
      dataIndex: "keycloak",
      keycloak: "checked",
      authing: "checked",
    },
    {
      nametype: "Authing",
      title: t("solution.keycloak.table.tableList.item3"),
      dataIndex: "authing",
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item4"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item5"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item6"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item7"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item8"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item9"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item10"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item11"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item12"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item13"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item14"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item15"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item16"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item17"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item18"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item19"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item20"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item21"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item22"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item23"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item24"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item25"),
      keycloak: "checked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item26"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item27"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item28"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item29"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item30"),
      keycloak: "unchecked",
      authing: "checked",
    },
    {
      title: t("solution.keycloak.table.tableList.item31"),
      keycloak: "unchecked",
      authing: "checked",
    },
  ];

  return (
    <div className="keycloak-page">
      <Helmet>
        <title>
          开源 Keycloak ，企业级身份云 Authing，零信任方案 -Authing 身份云
        </title>
      </Helmet>
      <Header mode="light" />
      <SolutionIndustryBanner
        title={t("solution.keycloak.banner.title")}
        subtitle={t("solution.keycloak.banner.subtitle")}
        imgUrl="//files.authing.co/authing-website/solution-banner-keycloak-v2.png"
      />
      {/* <SolutionIndustryCustomer /> */}
      <SolutionSceneIntro
        scene={
          <>
            <div className="item">{t("solution.keycloak.intro.descript1")}</div>
            <div className="item">{t("solution.keycloak.intro.descript2")}</div>
            <div className="item">{t("solution.keycloak.intro.descript3")}</div>
          </>
        }
      />
      <SolutionSceneValue value={t("solution.keycloak.value.title")} />
      <SolutionSceneTable data={data} />
      <SolutionSceneKeycloakCompare />
      <SolutionIndustrySupport
        supportTitle={t("solution.scene.title-support")}
        noLastBlock
      />

      <CommonPageLink pagesLink={pagesLink} />

      <HomeTryOn hasBg />

      <Footer />
    </div>
  );
};
